export default __webpack_public_path__ + "static/media/gallery29.54fce8cd.jpg";